/* eslint-disable no-unused-vars */
import $ from "jquery";
import axios from "axios";
import Cookies from "js-cookie";
import "./jquery.maxlength.min";

import { Constants } from "../../constants";

require("jquery-ui/ui/widgets/sortable");
require("jquery-ui/ui/widgets/autocomplete");

$(function () {
  /*-----------------------
    side bar menu
    -------------------------*/
  $("#nav-left-btn").on("click", function () {
    $("#nav-left-sidebar").toggleClass("active");
    $(".dashboard-wrapper").toggleClass("pull-right");
  });

  $(".nav-item").on("click", function (e) {
    $(this).toggleClass("open");
  });

  /*-----------------------
    image upload view
    -------------------------*/
  function imgView(elm) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $("#" + elm).attr("src", e.target.result);
    };
    reader.readAsDataURL(this.files[0]);
  }

  /*-----------------------
    maxlength
    -------------------------*/
  $("[maxlength]").maxlength();

  /*-----------------------
    array includes
    -------------------------*/
  function includes(array, string) {
    return array.includes(string);
  }

  /*-----------------------
    Overrides the default autocomplete filters function
    to search only from the beginning of the string written
    -------------------------*/
  $.ui.autocomplete.filter = function (array, term) {
    var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(term), "i");
    return $.grep(array, function (value) {
      return matcher.test(value.label || value.value || value);
    });
  };

  /*-----------------------
    operator position
    -------------------------*/
  $("#table-operator tbody").sortable({
    update: function (event, ui) {
      $("#loader-spinner").fadeIn("fast");

      var positions = [];
      var api = process.env.VUE_APP_API_URL;
      var accessToken = Cookies.get(Constants.API_TOKEN);

      $(this)
        .children()
        .each(function (index) {
          if ($(this).attr("data-position") != index + 1) {
            $(this)
              .attr("data-position", index + 1)
              .addClass("updated");

            $(".updated").each(function () {
              let id = $(this).attr("data-id");
              let pos = $(this).attr("data-position");

              $("#row-" + id).html(pos);
              positions.push({ id, position: pos });
              $(this).removeClass("updated");
            });
          }
        });

      axios
        .put(
          `${api}/operator/position/update`,
          { operator: positions },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then(function () {
          $("#loader-spinner").fadeOut("slow");
          $.alert("position updated successfull");
        });
    },
  });

  /*-----------------------
    package position
    -------------------------*/
  $("#table-package tbody").sortable({
    update: function (event, ui) {
      $("#loader-spinner").fadeIn("fast");

      var positions = [];
      var api = process.env.VUE_APP_API_URL;
      var accessToken = Cookies.get(Constants.API_TOKEN);

      $(this)
        .children()
        .each(function (index) {
          if ($(this).attr("data-position") != index + 1) {
            $(this)
              .attr("data-position", index + 1)
              .addClass("updated");

            $(".updated").each(function () {
              let id = $(this).attr("data-id");
              let pos = $(this).attr("data-position");

              // $("#row-" + id).html(pos);
              $(`#row-${id} input`).val(pos);
              positions.push({ id, position: pos });
              $(this).removeClass("updated");
            });
          }
        });

      axios
        .put(
          `${api}/package/position/update`,
          { package: positions },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then(function () {
          $("#loader-spinner").fadeOut("slow");
          $.alert("Position updated successfully");
        });
    },
  });

  /*-----------------------
    blog post position
    -------------------------*/
  $("#table-blog-post tbody").sortable({
    update: function (event, ui) {
      $("#loader-spinner").fadeIn("fast");

      var positions = [];
      var api = process.env.VUE_APP_API_URL;
      var accessToken = Cookies.get(Constants.API_TOKEN);

      $(this)
        .children()
        .each(function (index) {
          if ($(this).attr("data-position") != index + 1) {
            $(this)
              .attr("data-position", index + 1)
              .addClass("updated");

            $(".updated").each(function () {
              let id = $(this).attr("data-id");
              let pos = $(this).attr("data-position");

              $("#row-" + id).html(pos);
              positions.push({ id, position: pos });
              $(this).removeClass("updated");
            });
          }
        });

      axios
        .put(
          `${api}/blog-post/position/update`,
          { post: positions },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then(function () {
          $("#loader-spinner").fadeOut("slow");
          $.alert("position updated successfull");
        });
    },
  });

  /*-----------------------
    destination post position
    -------------------------*/
  $("#table-destination-post tbody").sortable({
    update: function (event, ui) {
      $("#loader-spinner").fadeIn("fast");

      var positions = [];
      var api = process.env.VUE_APP_API_URL;
      var accessToken = Cookies.get(Constants.API_TOKEN);

      $(this)
        .children()
        .each(function (index) {
          if ($(this).attr("data-position") != index + 1) {
            $(this)
              .attr("data-position", index + 1)
              .addClass("updated");

            $(".updated").each(function () {
              let id = $(this).attr("data-id");
              let pos = $(this).attr("data-position");

              $("#row-" + id).html(pos);
              positions.push({ id, position: pos });
              $(this).removeClass("updated");
            });
          }
        });

      axios
        .put(
          `${api}/destination-post/position/update`,
          { post: positions },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then(function () {
          $("#loader-spinner").fadeOut("slow");
          $.alert("position updated successfull");
        });
    },
  });
});
